<div class="wrapper">
  <app-auth-header/>

  <div class="middle custom-login-box">
    <div class="form-container ">
       <div class="w-full flex justify-content-center ">
        <div class="text-xl mt-4 mx-5">Εισάγετε τα στοιχεία χρήστη</div>
      </div>

      <eo-form
        #eoForm
        submitButtonStyleClass="w-full p-fluid"
        submitButtonDivStyleClass="px-3 pb-3"
        [config]="getFormConfig()"
        (formSubmit)="onSubmit($event)"
        [submitButtonLoading]="isSubmitLoading()"
        [submitButtonLabel]="getSubmitButtonLabel()"
      />

      <div class="w-full flex justify-content-left mt-3 ml-3 pb-3 link-user-manual">
        <a href="javascript:void(0);"
           (click)="forgotPwdDialog.show()">
          Ξέχασα τον κωδικό μου
        </a>
        <app-forgot-password-dialog #forgotPwdDialog />
      </div>
    </div>
    <div class="menu-logo-wrapper">
      <img
        class="menu-logo-img"
        src="./assets/icons/ellada2.png"
        alt="Ellada Logo"
      />
    </div>
  </div>

  <app-auth-footer/>
</div>
